import styled from '@emotion/styled';

const LoadingElement = styled('div')({
  opacity: 0.5,
  textAlign: 'center',
  width: '100%',
});

export default LoadingElement;
